

















import { Component, Vue } from 'vue-property-decorator';
import { showAxiosErrorMessage } from '@/utils';

import Btn from '@/components/Btn.vue';
import Field from '@/components/Field.vue';
import TextField from '@/components/TextField.vue';

@Component({
  name: 'confirm-reset-password-page',
  components: { Btn, Field, TextField }
})
export default class ConfirmResetPasswordComponent extends Vue {
  /**
   * Loading data into the system
   */
  public loading = false;

  /**
   * When the form should show messages
   */
  public showMessages = false;

  /**
   * The email that needs to reset
   */
  public email = '';

  /**
   * The password that needs to reset
   */
  public password = '';

  /**
   * Click event when we want to reset the password
   */
  public async resetPassword() {
    if (this.email.length > 0 && this.password.length > 0) {
      this.showMessages = false;
      try {
        this.loading = true;
        if (await this.$store.dispatch('resetPasswordVerification', { Token: this.$route.params.token, Email: this.email, Password: this.password })) {
          this.$router.push('/user/login');
        }
      } catch(ex) {
        showAxiosErrorMessage(ex);
      } finally {
        this.loading = false;
      }
    } else {
      this.showMessages = true;
    }
  }
}
